export default {
  filters: {
    items(value) {
      return `${value} ${value > 1 ? 'Items' : 'Item'}`;
    },
  },
};
